import type { ReadinessResponse } from "@cleany/platform-contracts";

export type PlatformState = "checking" | "ready" | "unavailable";

export function readinessState(response: ReadinessResponse | null): PlatformState {
  if (!response) return "checking";
  return response.status === "ok" ? "ready" : "unavailable";
}
